import type { ReactNode } from "react";
import type {
  CarouselId,
  CarouselItemType,
} from "src/website-apps/shared/components/carousel-module/carousel-analytics-event";
import { useCarouselItemInView } from "src/website-apps/shared/components/carousel-module/use-carousel-item-in-view";
import { carouselItemRecipe } from "./performer-carousel.recipe";

interface CarouselItemSlotProps {
  itemId: string | number;
  itemIndex: number;
  itemCount: number;
  carouselId: CarouselId;
  itemType?: CarouselItemType | undefined;
  categoryId?: number | undefined;
  onItemHover: (itemId: string | number, itemIndex: number) => void;
  className?: string | undefined;
  children: ReactNode;
}

/**
 * Wrapper around a single carousel item. Owns the per-item IntersectionObserver
 * via {@link useCarouselItemInView} so each item fires its own `item-in-view`
 * UAE event when it crosses 50% visibility — extracted into a component so the
 * hook is called once per slot instead of inside a map.
 */
export const CarouselItemSlot = ({
  itemId,
  itemIndex,
  itemCount,
  carouselId,
  itemType,
  categoryId,
  onItemHover,
  className = carouselItemRecipe,
  children,
}: CarouselItemSlotProps) => {
  const inViewRef = useCarouselItemInView({
    carouselId,
    itemId,
    itemIndex,
    itemCount,
    itemType,
    categoryId,
  });

  return (
    <div
      ref={inViewRef}
      className={className}
      onMouseEnter={() => {
        onItemHover(itemId, itemIndex);
      }}
    >
      {children}
    </div>
  );
};
